
import { Component, Inject, Vue } from 'vue-property-decorator';
import GlobalViewModel from '../state/GlobalViewModel';
import { Subscription } from 'rxjs';

@Component({})
export default class ErrorReportsFrame extends Vue {
    public showError = false;

    @Inject() private readonly globalViewModel!: GlobalViewModel;
    private showErrorSubscription = new Subscription();

    public created(): void {
        this.showErrorSubscription = this.globalViewModel.isErrorActive.subscribe(errorActive => {
            this.showError = errorActive;
        });
    }

    public beforeDestroy(): void {
        this.showErrorSubscription.unsubscribe();
    }

    public dismissError(): void {
        this.globalViewModel.dismissError();
    }
}
